import { QualificationDetailSortEnum } from "../../../common/enums/QualificationDetailSortEnum";
import { setSortEmployees } from "../QualificationDetailSlice";
import { Dispatch } from "redux";

interface Props {
    dispatch: Dispatch;
    sortEmployees: {
        sortName: string;
        isSorted: boolean;
    };
}

export const handleEmployeeSort = (props: Props) => () => {
    const { dispatch, sortEmployees } = props;

    dispatch(
        setSortEmployees({
            sortName: sortEmployees.isSorted
                ? QualificationDetailSortEnum.EMPLOYEE_NAME_ASC
                : QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
            isSorted: !sortEmployees.isSorted,
        }),
    );
};
